import { render, staticRenderFns } from "./ProductDetailDesk.vue?vue&type=template&id=9a804a48&scoped=true&"
import script from "./ProductDetailDesk.vue?vue&type=script&lang=js&"
export * from "./ProductDetailDesk.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailDesk.vue?vue&type=style&index=0&id=9a804a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a804a48",
  null
  
)

export default component.exports